import { VendorResponseTypes } from '../packages-module/models/searchPackage';
import * as moment from 'moment';
export class HardDeclineReason
{
    id: number;
    displayMessage: string;
    searchType: VendorResponseTypes;
    userId: number;
    declineNote : string;
    dateSet : moment.Moment;
    userName : string;
    screeningId : number;
    isCrimGridHardDecline : boolean;
    overrideCalcs : boolean;
    overrideNote : string

    
    public get noteToShow() : string {
        return this.overrideCalcs ? this.overrideNote : this.declineNote;
    }
    
}

export class ReviewRequiredReason {
    id: number;
    //ScreeningId: number;
    //ReportNumber: number;
    reasonText: number;
    dateAdded : Date;
    userName : string;
}